import { IconV2 } from 'components/common/IconV2/IconV2';
import type { SmallIconV2Props } from 'components/common/IconV2/IconV2.types';

const InfoOutlineSmallIcon = (props: SmallIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 16 16">
    <circle cx="8" cy="8" r="7" stroke="currentcolor" />
    <circle cx="7.95" cy="5.7" r=".7" fill="currentcolor" />
    <path stroke="currentcolor" strokeLinecap="round" d="M8 8v3.25" />
  </IconV2>
);

export default InfoOutlineSmallIcon;
